/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetUserNotificationsResponseDto
 */
export interface GetUserNotificationsResponseDto {
    /**
     * Notification ID
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'deletedAt': string;
    /**
     * User ID who received the notification (null for global notifications)
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'userId'?: string;
    /**
     * Type of notification
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'type': GetUserNotificationsResponseDtoTypeEnum;
    /**
     * Notification title
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'title': string;
    /**
     * Notification body message
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'body': string;
    /**
     * Delivery status of the notification
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'deliveryStatus': GetUserNotificationsResponseDtoDeliveryStatusEnum;
    /**
     * Whether the notification has been read
     * @type {boolean}
     * @memberof GetUserNotificationsResponseDto
     */
    'isRead': boolean;
    /**
     * When the notification was read
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'readAt'?: string;
    /**
     * When the notification was sent
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'sentAt'?: string;
    /**
     * Failure reason if delivery failed
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'failureReason'?: string;
    /**
     * Type-specific notification data
     * @type {object}
     * @memberof GetUserNotificationsResponseDto
     */
    'data': object;
    /**
     * Activity ID associated with the notification
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'activityId'?: string;
    /**
     * Submission ID associated with the notification
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'submissionId'?: string;
    /**
     * Participation ID associated with the notification
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'participationId'?: string;
    /**
     * Challenge ID associated with the notification
     * @type {string}
     * @memberof GetUserNotificationsResponseDto
     */
    'challengeId'?: string;
    /**
     * Image URLs associated with the notification
     * @type {Array<string>}
     * @memberof GetUserNotificationsResponseDto
     */
    'imageUrls'?: Array<string>;
}

export const GetUserNotificationsResponseDtoTypeEnum = {
    Announcement: 'announcement',
    SubmissionApproved: 'submission_approved',
    SubmissionDeclined: 'submission_declined',
    ParticipationCompleted: 'participation_completed',
    PaymentPaid: 'payment_paid',
    PaymentFailed: 'payment_failed',
    PaymentExpired: 'payment_expired',
    ChallengeStarting: 'challenge_starting',
    ChallengeCompleted: 'challenge_completed',
    ChallengeAnnouncement: 'challenge_announcement',
    ProgressSummary: 'progress_summary',
    SocialActivity: 'social_activity',
    LikedPost: 'liked_post',
    LikedComment: 'liked_comment',
    CommentedOnPost: 'commented_on_post',
    RepliedToComment: 'replied_to_comment'
} as const;

export type GetUserNotificationsResponseDtoTypeEnum = typeof GetUserNotificationsResponseDtoTypeEnum[keyof typeof GetUserNotificationsResponseDtoTypeEnum];
export const GetUserNotificationsResponseDtoDeliveryStatusEnum = {
    Pending: 'pending',
    Sent: 'sent',
    Failed: 'failed',
    Retry: 'retry'
} as const;

export type GetUserNotificationsResponseDtoDeliveryStatusEnum = typeof GetUserNotificationsResponseDtoDeliveryStatusEnum[keyof typeof GetUserNotificationsResponseDtoDeliveryStatusEnum];


